import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import BotBPass from "../app/(general-header)/botb-pass/page";

const root = createRoot(document.getElementById("botb-pass-page-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <BotBPass />
    </StoreProvider>
  </React.StrictMode>
);
